import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import colorsharp2 from '../assets/img/color-sharp2.png';
import {
    ProjectDescription,
    ProjectCard,
    IsotopeLayout,
    IsotopeSkeleton,
    CardSkeleton,
    Loader
} from '../components';
import { getProjects, getProjectById } from '../utils/groq';
import { urlFor } from '../client';

const useToggle = function (state) {
    const [show, setShow] = React.useState(state)

    let toggle = () => {
        setShow(v => !v)
    }

    return [show, toggle]
}

const Projects = () => {
    const [projects, setProjects] = React.useState([])
    const [projectsLoaded, setProjectsLoaded] = React.useState(false)
    const [projectDetailLoaded, setProjectDetailLoaded] = React.useState(false)
    const [currentProject, setCurrentProject] = React.useState({})
    const [modal, toggle] = useToggle(false)

    React.useEffect(() => {
        getProjects()
            .then(data => {
                setProjects(data)
                setProjectsLoaded(true)
            })
            .catch(error => console.log(error))
    }, [])

    const showProject = (id, title, links) => {
        getProjectById(id)
            .then(project => {
                project = project.length > 0 ? project[0] : {}
                setCurrentProject({ ...project, title, links })
                setProjectDetailLoaded(true)
            })
            .catch(error => console.log(error))
        toggle()
    }

    const closeModal = () => {
        toggle()
        setProjectDetailLoaded(false)
        setCurrentProject({})
    }

    return (
        <section className="project" id="projects">
            <Container>
                <Row>
                    <Col>
                        <h2 className="mb-5 ">Mon Espace <span className='text-purple'>Portfolio</span> Créatif</h2>
                        {!projectsLoaded && <IsotopeSkeleton>
                            <CardSkeleton cardsNumber={6} variant="project" />
                        </IsotopeSkeleton>}
                        {projectsLoaded && <IsotopeLayout
                            filterKeys={["ui ux", "dev web", "community"]}
                            defaultPreview = "ui-ux"
                            isotopeNavigationClassName="mb-5 justify-content-center align-items-center gap-2"
                            containerClassName="row"
                        >
                            {
                                projects.map((project, index) => (
                                    <ProjectCard
                                        key={`project-${project._id}`}
                                        id={project._id}
                                        imgUrl={urlFor(project.imgCoverUrl)}
                                        links={{
                                            gitHub: project.codeLink,
                                            website: project.projectLink
                                        }}
                                        {...project}
                                        handleClick={showProject}
                                        className={`${project.tags.map(v => v.replace(/ /g, '-')).join(' ')}`}
                                        animation={{
                                            "data-zanim-xs": `{"delay": 0.${index + 2}}`,
                                            "data-zanim-trigger": "scroll"
                                        }}
                                    />
                                ))
                            }
                        </IsotopeLayout>}
                        {
                           modal && (projectDetailLoaded ?
                            (<ProjectDescription
                                show={modal}
                                onHide={closeModal}
                                {...currentProject}
                            />)
                            : (<Loader />))
                        }
                    </Col>
                </Row>
            </Container>
            <img src={colorsharp2} alt="" className="background-image-right" />
        </section>
    )
}
export default Projects;